import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {Icon, Icons} from '@pb/kit-component-icon';

import {
    active,
    navIcon,
    navItem,
    sideNavContainer,
} from './side-nav.styles.module.styl';

type NavMenuItem = {
    path: string;
    title: string;
    icon: (typeof Icons)[keyof typeof Icons];
};

const NAV_MENU_ITEMS: NavMenuItem[] = [
    {path: '/company-search', title: 'Search Company', icon: Icons.SEARCH},
    {path: '/company-management', title: 'Company Management', icon: Icons.EDIT},
    {path: '/rna-mapping', title: 'RNA Mapping', icon: Icons.LIST},
    {path: '/company-list', title: 'Company List', icon: Icons.TASKS},
    {path: '/holiday', title: 'Holiday', icon: Icons.CALENDAR},
    {path: '/push-companies', title: 'Push Companies', icon: Icons.ARROW_UP_RIGHT},
    {path: '/manage-event-calendar', title: 'Manage Event Calendar', icon: Icons.CALENDAR},
];

const SideNav: React.FC = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();

    const isActive = (path: string) =>
        pathname === path || pathname.startsWith(`${path}/`);

    return (
        <nav className={sideNavContainer}>
            {NAV_MENU_ITEMS.map(item => (
                <div
                    key={item.path}
                    className={`${navItem} ${isActive(item.path) ? active : ''}`}
                    onClick={() => navigate(item.path)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={e => e.key === 'Enter' && navigate(item.path)}>
                    <span className={navIcon}>
                        <Icon type={item.icon} size="Size_16"/>
                    </span>
                    {item.title}
                </div>
            ))}
        </nav>
    );
};

export default SideNav;
